import { render, staticRenderFns } from "./HistoricoLista.vue?vue&type=template&id=0c4c1554&scoped=true&"
import script from "./HistoricoLista.vue?vue&type=script&lang=js&"
export * from "./HistoricoLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c1554",
  null
  
)

export default component.exports